/**
 * Loads the Rust Stonex kernels.
 *
 * Reuses the registration loader's resolution, which already knows where the
 * `pointcloud-parser` package sits in each of the four builds - extension host,
 * webview, standalone page and Node - after an absolute-path alias silently
 * failed to apply in one of them and left the webview unable to load anything.
 */
// Browser builds replace this exact request with the browser loader. The
// relative request itself always resolves to a real module, so a missed build
// mapping cannot turn into an activation-time missing-module stub.
import { loadRegistrationWasm } from '../registration/wasmLoader';
export async function loadStonexWasm() {
    const wasm = (await loadRegistrationWasm());
    return wasm && typeof wasm.StonexColourSession === 'function' ? wasm : null;
}
